var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticStyle:{"text-decoration":"none","font-weight":"600","text-align":"right"}},[_vm._v(_vm._s(_vm.moduleNameLocal))])]),(_vm.localModulePermissions[_vm.moduleName])?_c('div',{staticClass:"col-md-6"},[_c('field',{attrs:{"label":"Read","col-class":"col-md-2","params":{
				type: 'btn-group',
				buttons: [
					{text: 'Read',value:true},
					{icon: 'fa-times',value:false}
				]
			}},on:{"change":_vm.permsChanged},model:{value:(_vm.localModulePermissions[_vm.moduleName].read),callback:function ($$v) {_vm.$set(_vm.localModulePermissions[_vm.moduleName], "read", $$v)},expression:"localModulePermissions[moduleName].read"}}),_c('field',{attrs:{"label":"Write","col-class":"col-md-2","params":{
				type: 'btn-group',
				buttons: [
					{text: 'Write',value:true},
					{icon: 'fa-times',value:false}
				]
			}},on:{"change":_vm.permsChanged},model:{value:(_vm.localModulePermissions[_vm.moduleName].write),callback:function ($$v) {_vm.$set(_vm.localModulePermissions[_vm.moduleName], "write", $$v)},expression:"localModulePermissions[moduleName].write"}}),_c('hr')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }